<script setup>
const props = defineProps({
  blok: Object,
  theme: String,
  size: String,
})
const emits = defineEmits(['onClick'])
const { button, fetchButton } = useButton()
await fetchButton()

const ringClasses = computed(() => {
  switch (props.blok.ring) {
    case 'none':
      return ''
    case 'green':
      return 'ring-green-500/25 hover:ring-4'
    case 'blue':
      return 'ring-[#202edd]/25 hover:ring-4'
    default:
      return 'ring-secondary-red-100/25 hover:ring-4'
  }
})

const themeClasses = computed(() => {
  switch (props.blok.type || props.theme) {
    case 'outline':
      return 'border border-secondary-red-100 !text-secondary-red-100 [&>*]:!text-secondary-red-100'
    case 'text':
      return 'text-primary !p-0 !ring-0 [&>*]:!text-primary'
    case 'green':
      return 'bg-green-500 !text-white [&>*]:!text-white'
    case 'blue':
      return 'bg-blue-500 !text-white [&>*]:!text-white'
    case 'yellow':
      return 'bg-yellow-500 !text-white [&>*]:!text-white'
    default:
      return 'bg-red-gradient !text-white [&>*]:!text-white'
  }
})

const paddingClasses = computed(() => {
  switch (props.blok.size) {
    case 'xs':
      return 'px-3 py-1.5'
    case 'sm':
      return 'px-3.5 py-2'
    case 'lg':
      return 'px-6 py-3'
    case 'xl':
      return 'px-6.5 py-4'
    default:
      return 'px-4 py-3'
  }
})

const textFontSize = computed(() => {
  switch (props.blok.size) {
    case 'xs':
      return 'text-xs'
    case 'sm':
      return 'text-sm'
    case 'lg':
      return 'text-lg'
    case 'xl':
      return 'text-xl'
    default:
      return 'text-md'
  }
})

const defaultWidth = computed(() => {
  switch (props.blok.size) {
    default:
      return 'w-auto'
  }
})

const classes = computed(() => `${ringClasses.value} ${themeClasses.value} ${paddingClasses.value} ${props.blok.liquid ? 'w-full' : defaultWidth.value}`)

function handleClick(event) {
  emits('onClick', event)
}
function filteredButton() {
  for (let i = 0; i < button.value.length; i++) {
    const item = button.value[i]
    if (item.uuid === props.blok.label)
      return item.content.label
  }
}
</script>

<template>
  <!-- eslint-disable -->
  <NuxtLink
    v-if="blok.link.url || blok.link.cached_url"
    :to="localePath({
      path: rootedPath(blok.link.url ? blok.link.url : blok.link.cached_url),
    })"
  >
    <span
      class="flex justify-center items-center h-full rounded-full text-center font-semibold leading-6 transition-shadow duration-200 ease-in-out disabled:cursor-not-allowed disabled:opacity-50 block gap-x-1"
      :disabled="props.blok.disabled"
      :class="[classes, blok.css, blok.rounded, textFontSize]"
      @click="handleClick"
    >
      <i v-if="blok.icon" v-html="blok.icon"></i>
      {{ filteredButton() }}
    </span>
  </NuxtLink>
  <a
    v-else-if="blok.other || blok.external"
    :href="blok.other ? blok.other : blok.external"
    :target="blok.external ? '_blank' : ''"
  >
    <span
      class="flex justify-center items-center h-full rounded-full text-center font-semibold leading-6 transition-shadow duration-200 ease-in-out disabled:cursor-not-allowed disabled:opacity-50 block"
      :disabled="props.blok.disabled"
      :class="[classes, blok.css, blok.rounded, textFontSize]"
      @click="handleClick"
    >
        {{ filteredButton() }}
    </span>
  </a>
  <div v-else-if="blok.text_only">
    <span>{{ filteredButton() }}</span>
  </div>
  <div
    v-else
    class="flex items-center"
  >
    <UISpinner class="text-white/80 w-8 h-8" />
  </div>
</template>
